<template>
  <form @submit.prevent="submit" class="form">
    <slot name="text"></slot>
    <div
      class="form__field"
      v-for="field in form" :key="field.name"
    >
      <component
        v-model="field.value"
        :autocomplete="field.autocomplete"
        :is="field.component"
        :type="field.type"
        :label="field.label"
        :name="field.name"
        :placeholder="field.placeholder"
        :hint="field.hint"
        :inputmode="field.inputmode"
        :block="field.block"
        :error="errors.first(field.name) ? field.errorText || 'Введите значение' : ''"
        v-validate="field.rules"
      />
    </div>
    <div class="form__submit">
      <Button type="submit" :disabled="pending">{{ pending ? 'Отправка...' : 'Отправить' }}</Button>
    </div>
  </form>
</template>

<script>
  import anime from 'animejs'
  import Checkbox from '@/components/Checkbox.vue'
  import Input from '@/components/Input.vue'
  import http from '@/ulils/http'

  function Form () {
    return [
      new Field({
        component: Input,
        value: null,
        name: 'name',
        placeholder: 'Как к вам обращаться',
        rules: { required: true }
      }),
      new Field({
        component: Input,
        value: null,
        name: 'company',
        placeholder: 'Название вашей организации',
        rules: { required: true }
      }),
      new Field({
        component: Input,
        value: null,
        name: 'post',
        placeholder: 'Должность',
        rules: { required: true }
      }),
      new Field({
        component: Input,
        value: null,
        name: 'email',
        placeholder: 'Электронная почта',
        rules: { required: true, email: true }
      }),
      new Field({
        component: Input,
        inputmode: 'numeric',
        value: null,
        name: 'phone',
        placeholder: 'Телефон',
        rules: { required: true }
      }),
      new Field({
        component: Input,
        value: null,
        name: 'comment',
        placeholder: 'Ваш комментарий'
      }),
      new Field({
        component: Checkbox,
        value: null,
        name: 'legal',
        errorText: 'Необходимо ваше согласие',
        label: 'Уведомлен о том, что услуга предоставляется только юридическим лицам',
        rules: { required: true, checked: true }
      }),
      new Field({
        component: Checkbox,
        value: null,
        name: 'policy',
        errorText: 'Необходимо ваше согласие',
        label: `Ознакомлен и&nbsp;согласен с&nbsp;<a href="https://filearchive.cnews.ru/img/cnews/2021/01/15/Polozhenie-o-poryadke-obrabotki-PDn.pdf" class="link link--underline link--blue" target="_blank">Политикой сбора, хранения и&nbsp;обработки персональных данных АО&nbsp;&laquo;Инфосистемы Джет&raquo;</a>`,
        rules: { required: true, checked: true }
      })
    ]
  }

  function Field (options = {}) {
    return Object.assign({
      autocomplete: options.autocomplete || '',
      block: options.block || true,
      component: options.component,
      name: options.name || null,
      value: options.value || null,
      placeholder: options.placeholder || null,
      hint: options.hint || null,
      inputmode: options.inputmode || null,
      type: options.type || null,
      label: options.label || null,
      rules: options.rules || {},
      errorText: options.errorText || null
    })
  }

  export default {
    data () {
      return {
        pending: false,
        form: new Form()
      }
    },
    methods: {
      rewind (scrollTop, duration = 500) {
        anime({
          targets: document.querySelector('.page'),
          easing: 'easeInOutQuad',
          scrollTop,
          duration,
        })
      },
      async submit () {
        const valid = await this.$validator.validate()
        if (!valid) {
          this.rewind(this.$el.offsetTop - 30)
          return
        } else {
          const data = this.form.reduce((acc, field) => {
            acc[field.name] = field.value
            return acc
          }, {})

          this.pending = true
          try {
            await http.post('/form.php', { form: data })
            this.rewind(0)
            this.$emit('submit')
          } catch (e) {
            alert('Не удалось отправить форму')
            console.error(e)
          }
          this.pending = false
        }
      }
    }
  }
</script>


<style lang="scss">
  .form {
    @include more(scale) {
      border: 1px solid $color-cyan;
      background: $color-navy;
      padding: 60px;
    }
    @include mq(scale) {
      padding: 10rem;
    }
  }
  .form__field {
    margin-bottom: 34px;
    @include less(tablet) {
      margin-bottom: 25px;
    }
    @include screen-height(low) {
      margin-bottom: 15px;
    }
  }
  .form__submit {
    @include more(scale) {
      margin-top: 40px;
    }
  }
</style>
